/** ຊື່ ແລະ parent ພິເສษ (ບໍ່ພໍໃນ sidebar / heuristic) */
export const ROUTE_BREADCRUMB_LABELS: Record<string, string> = {
  "/app/profile": "ໂປຣໄຟລ໌",
  "/app/users/$id": "ລາຍລະອຽດຜູ້ໃຊ້",
  "/app/hr/employees/$userId": "ລາຍລະອຽດພະນັກງານ",
  "/app/hr/leave/requests/new": "ສ້າງຄຳຂໍລາ",
  "/app/hr/leave/requests/$id": "ລາຍລະອຽດຄຳຂໍລາ",
  "/app/hr/leave/requests/$id/edit": "ແກ້ໄຂຄຳຂໍລາ",
  "/app/hr/leave/entitlements/employee/$employeeId": "ສິດລາຕາມພະນັກງານ",
  "/app/hr/overtime/requests/new": "ສ້າງຄຳຂໍ OT",
  "/app/hr/overtime/requests/new-for-employee": "ສ້າງ OT ໃຫ້ພະນັກງານ",
  "/app/hr/overtime/requests/$id": "ລາຍລະອຽດ OT",
  "/app/hr/salary-advance/new": "ສ້າງຄຳຂໍເບິກເງິນເດືອນລ່ວງໜ້າ",
  "/app/hr/salary-advance/me": "ຄຳຂໍເບິກຂອງຂ້ອຍ",
  "/app/hr/salary-advance/me/new": "ສ້າງຄຳຂໍເບິກ",
  "/app/hr/salary-advance/me/$id": "ລາຍລະອຽດຄຳຂໍເບິກ",
  "/app/management/meetings/new": "ບັນທຶກປະຊຸມໃໝ່",
  "/app/management/meetings/$id": "ລາຍລະອຽດປະຊຸມ",
  "/app/management/meetings/$id/edit": "ແກ້ໄຂປະຊຸມ",
  "/app/management/meetings/$id/pdf-preview": "PDF ປະຊຸມ",
  "/app/management/projects/new": "ສ້າງໂຄງການ",
  "/app/management/projects/$id": "ລາຍລະອຽດໂຄງການ",
  "/app/management/projects/$id/edit": "ແກ້ໄຂໂຄງການ",
  "/app/management/monthly-reports/new": "ສ້າງລາຍງານ",
  "/app/management/monthly-reports/$id": "ລາຍລະອຽດລາຍງານ",
  "/app/management/monthly-reports/$id/edit": "ແກ້ໄຂລາຍງານ",
  "/app/management/okr-kpi/explain": "ອະທິບາຍ KPI",
  "/app/documents/new": "ສ້າງເອກະສານ",
  "/app/documents/$id": "ລາຍລະອຽດເອກະສານ",
  "/app/documents/$id/edit": "ແກ້ໄຂເອກະສານ",
  "/app/documents/$id/pdf-preview": "PDF ເອກະສານ",
  "/app/checklists/new": "ສ້າງ Checklist",
  "/app/checklists/$id": "ລາຍລະອຽດ Checklist",
  "/app/checklists/$id/edit": "ແກ້ໄຂ Checklist",
  "/app/checklists/execution-history/$executionId": "ລາຍລະອຽດການບັນທຶກ",
};

export const ROUTE_BREADCRUMB_PARENTS: Record<string, string> = {
  "/app/hr/leave/requests/new": "/app/hr/leave/history",
  "/app/hr/leave/requests/$id": "/app/hr/leave/history",
  "/app/hr/leave/requests/$id/edit": "/app/hr/leave/requests/$id",
  "/app/hr/overtime/requests/new": "/app/hr/overtime/requests",
  "/app/hr/overtime/requests/new-for-employee": "/app/hr/overtime/requests",
  "/app/hr/overtime/requests/$id": "/app/hr/overtime/requests",
  "/app/hr/salary-advance/new": "/app/hr/salary-advance",
  "/app/hr/salary-advance/me/new": "/app/hr/salary-advance/me",
  "/app/hr/salary-advance/me/$id": "/app/hr/salary-advance/me",
  "/app/management/meetings/$id/edit": "/app/management/meetings/$id",
  "/app/management/meetings/$id/pdf-preview": "/app/management/meetings/$id",
  "/app/management/projects/$id/edit": "/app/management/projects/$id",
  "/app/management/monthly-reports/$id/edit": "/app/management/monthly-reports/$id",
  "/app/documents/$id/edit": "/app/documents/$id",
  "/app/documents/$id/pdf-preview": "/app/documents/$id",
  "/app/checklists/$id/edit": "/app/checklists/$id",
  "/app/contracts/$id/edit": "/app/contracts/$id",
  "/app/contracts/$id/pdf-preview": "/app/contracts/$id",
};

export const SEGMENT_LABELS: Record<string, string> = {
  new: "ສ້າງໃໝ່",
  edit: "ແກ້ໄຂ",
  settings: "ການຕັ້ງຄ່າ",
  audit: "ປະຫວັດກວດສອບ",
  expiring: "ໃກ້ຫມົດອາຍຸ",
  approvals: "ລາຍການອະນຸມັດ",
  history: "ປະຫວັດ",
  summary: "ສະຫຼຸບ",
  result: "ສະຫຼຸບຜົນ",
  "execution-history": "ປະຫວັດການບັນທຶກ",
  "pdf-preview": "PDF",
  preview: "ຕົວຢ່າງ",
  analysis: "ວິເຄາະ",
  submissions: "ການສົ່ງຟອມ",
  categories: "ຫມວດຫມູ່",
  entitlements: "ສິດລາ",
  types: "ປະເພດ",
  requests: "ຄຳຂໍ",
  rules: "ກົດການ",
  period: "ຕາມໄລຍະ",
  slip: "ໃບເງິນເດືອນ",
  records: "ບັນທຶກ",
  archive: "ເກັບໄວ້",
  versions: "ເວີຊັນ",
  explain: "ອະທິບາຍ",
  calculation: "ຄຳນວນ",
  actions: "ຕິດຕາມປະເດັນ",
  "$id": "ລາຍລະອຽດ",
  "$userId": "ລາຍລະອຽດ",
  "$employeeId": "ພະນັກງານ",
  "$executionId": "ການບັນທຶກ",
  "$submissionId": "ການສົ່ງ",
};
